import login from './auth/login.json'
import forgotPassword from './auth/forgotPassword.json'
import otpConfim from './auth/otpConfim.json'
import confimPassword from './auth/confimPassword.json'
import employeesList from './employees/list.json'
import employeesCreate from './employees/create.json'
import roleList from './role/list.json'
import roleCreatet from './role/create.json'
import common from './common.json'

export const LocaleTH = {
    ...common,
    
    ...login,
    ...forgotPassword,
    ...otpConfim,
    ...confimPassword,

    ...employeesList,
    ...employeesCreate,

    ...roleList,
    ...roleCreatet
}
